import {
  admin,
  auth,
  courses,
  learningAreas,
  learningPaths,
  search,
  users,
} from './routes/index'

export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/Home'),
  },
  ...admin,
  ...auth,
  ...courses,
  ...learningAreas,
  ...learningPaths,
  ...search,
  ...users,
  {
    // Always leave this as last one
    path: '/error/:status',
    name: 'error',
    component: () => import('@/pages/ErrorHandling'),
  },
  {
    // Always leave this as last one
    path: '*',
    component: () => import('@/pages/404'),
  },
]
